import iconsPng from '@/assets/img/png/icons';
import { TCriticalQuestion } from '@/types/Screener.types';
import { getColorFromPercentage } from '@/utils/getColorFromPercentage';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  HStack,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

type Props = {
  questions: TCriticalQuestion[];
};

const CriticalQuestions = ({ questions }: Props) => {
  const score = questions.length;

  const totalScoreX10 = score > 10 ? score : score * 10;
  const color = getColorFromPercentage(totalScoreX10);

  const [isAccordionExpanded, setIsAccordionExpanded] = React.useState(false);

  const onAccordionToggle = (expandedIndex: number) => {
    const isExpanded = expandedIndex === 0;
    setIsAccordionExpanded(isExpanded);
  };

  const isAccordionDisabled = questions.length === 0;

  return (
    <VStack width={'362px'} height={'100%'} display={'flex'} direction={'column'}>
      <VStack
        alignItems={'flex-start'}
        backgroundColor={'white'}
        borderRadius={'12px'}
        paddingX={'14px'}
        paddingY={'16px'}
        width={'full'}
        boxShadow={`0px 10px 30px 0px #4E1AEF0D`}
        gap={'20px'}
      >
        <HStack gap={'14px'} width={'full'}>
          <Image src={iconsPng.whiteExclamationOnPurpleTriangle} width={'28px'} height={'28px'} />
          <VStack alignItems={'flex-start'} width={'100%'} gap={'12px'}>
            <HStack justifyContent={'space-between'} width={'100%'}>
              <Text fontSize={'18px'} variant={'urbanistSmall'} color={'text.mediumBlue'} fontWeight={'600'}>
                Pressing Concerns
              </Text>
              <Text fontSize={'18px'} variant={'urbanistSmall'} color={'text.mediumBlue'} fontWeight={'800'}>
                {questions.length}
              </Text>
            </HStack>
            <HStack width={'100%'} height={'8px'} borderRadius={'10px'} bg="#F4F4F4">
              <VStack borderRadius={'10px'} height={'8px'} width={`${totalScoreX10}%`} bg={color} />
            </HStack>
          </VStack>
        </HStack>
        <Accordion
          width={'full'}
          borderColor={'white'}
          allowToggle
          onChange={onAccordionToggle}
          defaultIndex={isAccordionExpanded ? 0 : -1}
        >
          <AccordionItem isDisabled={isAccordionDisabled}>
            <AccordionButton paddingX={'4px'} paddingY={0}>
              <HStack width={'full'} justifyContent={'space-between'}>
                <Text fontSize={'16px'} variant={'urbanistSmall'} color={'text.mediumBlue'} fontWeight={'700'}>
                  {questions.length} concerns
                </Text>
                {!isAccordionDisabled && (
                  <HStack bg="#EFF7FE" paddingX={'10px'} paddingY={'6px'} borderRadius={'full'} gap={0}>
                    <Text fontSize={'10px'} variant={'urbanistSmall'} color={'text.mediumGray'} fontWeight={'700'}>
                      {isAccordionExpanded ? 'COLLAPSE' : 'EXPAND'}
                    </Text>
                    <AccordionIcon color={'text.mediumGray'} width={'18px'} />
                  </HStack>
                )}
              </HStack>
            </AccordionButton>
            <AccordionPanel padding={0} paddingTop={'20px'}>
              <VStack gap={'36px'} marginTop={'20px'} alignItems={'flex-start'}>
                {questions?.map((question) => {
                  const isCustom = question.question.includes('please specify');

                  return (
                    <HStack gap={'14px'} key={question.question}>
                      <Checkbox
                        isChecked={question.value as boolean}
                        isDisabled={true}
                        colorScheme="primary"
                        backgroundColor={'background.darkGray'}
                        borderColor={'background.darkGray'}
                        borderRadius={'4px'}
                        size={'lg'}
                        justifyContent={'center'}
                        alignItems={'center'}
                      />
                      <VStack alignItems={'flex-start'}>
                        <Text fontSize={'16px'} lineHeight={'20px'} variant={'urbanistSmall'} color={'text.mediumBlue'}>
                          {question.question}
                        </Text>
                        {isCustom && question?.text && (
                          <Text
                            fontSize={'16px'}
                            lineHeight={'20px'}
                            variant={'urbanistSmall'}
                            color={'text.mediumBlue'}
                            fontWeight={'600'}
                          >
                            {question.text}
                          </Text>
                        )}
                      </VStack>
                    </HStack>
                  );
                })}
              </VStack>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </VStack>
    </VStack>
  );
};

export default CriticalQuestions;
